export var EDGE_PAYLOAD_KEY = 'edge_payload';
